const HOPE =  {
    hope_address_base: "0xF8ecfA57ED030d9fa5258761Ff86542aF20CaA72",
    hope_address_base_testnet: "0xe27630fbc6d9F1E51cdF7a6A737f85d8aE59791B",
    hope_distributor_base: "0x8D339D01C84f2FA396ee318847447E9eeC6F59A1",
    hope_distributor_base_testnet: "0x58D890c0203e43946e62CbcF889B8840f63eCc6F",
    hope_staking_base_testnet: "0xd810222d882Ad4bD569318e4717565aCBD1f9FFB",
    hope_staking_base: "0x83E20D6f1B09B6Bc14E8729150C3245970bb27eA",
    hope_exchange_base: "0xEEFd4844Ed09E4919C083454350B6fAF26ab6985",
    dumpster_submission: '0x2A94456b6C1A6D2cDDF4e48a101459b66cBf2210'
} 

const Avalanche = {
    token_exchange_address: "0x0818817dc64fADf9a1eDd7A950f8C3e68efaDab1", 
    native_token_symbol: "AVAX",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base,
    dumpster_submission: HOPE.dumpster_submission
} 
const Base = {
    token_exchange_address: HOPE.hope_exchange_base, 
    native_token_symbol: "ETH",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base,
    stake_address: HOPE.hope_staking_base,
    dumpster_submission: HOPE.dumpster_submission
} 
const Bsc = {
    token_exchange_address: "0x0818817dc64fADf9a1eDd7A950f8C3e68efaDab1", 
    native_token_symbol: "ETH",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base,
    dumpster_submission: HOPE.dumpster_submission
} 
const Ethereum = {
    token_exchange_address: "0x0818817dc64fADf9a1eDd7A950f8C3e68efaDab1", 
    native_token_symbol: "ETH",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base,
    dumpster_submission: HOPE.dumpster_submission
}





const Solana = {
    token_exchange_address: "0x0000000000000000000000000000000000000000", 
    native_token_symbol: "Sol",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base
} 
const AVAX_FUJI = {
    token_exchange_address: "0xd5Bbe336680eF3457Fcceba7b160A77bb5f54bA1", 
    native_token_symbol: "AVAX",
    hope_address: HOPE.hope_address_base,
    hope_distributor: HOPE.hope_distributor_base
} 
const BSC_TESTNET = {
    token_exchange_address: "0x960873135941FE0d69209AF55Ae4c20D7C20E875", 
    native_token_symbol: "BNB",
    hope_address: HOPE.hope_address_base_testnet,
    hope_distributor: HOPE.hope_distributor_base_testnet
} 
const BASE_SEPOLIA = {
    token_exchange_address: "0x960873135941FE0d69209AF55Ae4c20D7C20E875", 
    stake_address: HOPE.hope_staking_base_testnet,
    native_token_symbol: "BNB",
    hope_address: HOPE.hope_address_base_testnet,
    hope_distributor: HOPE.hope_distributor_base_testnet
} 
 
export const getAddress = (networkID) => {
    if (networkID === 8453) return Base 
    if (networkID === 43114) return Avalanche 
    if (networkID === 56) return Bsc 
    if (networkID === 1) return Ethereum  
    if (networkID === 43113) return AVAX_FUJI 
    if (networkID === 97) return BSC_TESTNET  
    if (networkID === 84532) return BASE_SEPOLIA  
    if (networkID === "solana") return Solana  
}
